import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';
import { getWindowScrollTop } from '@opten/dom/get-window-scroll-top';
import { isPad } from '../../utilities/detection';

@Component({ className: 'js-header' })
export class Header implements OnInit {
	private _height: number;
	private _topCache: number;
	private _paddingTop: number | null = null;
	// private _sidebar: Sidebar;
	private _dropdowns: HTMLCollectionOf<Element>;

	// prevent multiple resizings to add more height
	// if it's the same height as before!
	private _cachedHeight: number | null = null;

	// if we don't have a tangram,
	// we always want to show the shadow!
	private _handleBoxShadow: boolean = true;

	constructor(private element: HTMLElement) {
		this._handleBoxShadow = !hasClass(element, '--shadow');
	}

	onInit() {
		this._dropdowns = document.getElementsByClassName(
			'js-navbar-mega-dropdown'
		);

		addClass(this.element, '--sticky');
		// this._sidebar = new Sidebar(
		// 	document.getElementsByClassName('js-sidebar')[0] as HTMLElement
		// );
		this._handleScroll();
		window.addEventListener('scroll', () => this._handleScroll());
	}

	public _update(top: number) {
		if (top !== null) {
			if (top !== this._topCache) {
				this._topCache = top;
				this.element.style.top = `${top}px`;
				this._hideDropdown();
			}
		}
	}

	private _hideDropdown() {
		if (this._dropdowns && this._dropdowns.length > 0) {
			let toggler;
			Array.from(this._dropdowns).forEach(dropdown => {
				if (dropdown.classList.contains('--show')) {
					removeClass(dropdown.parentElement, 'is-active');
					removeClass(dropdown, '--show');
					toggler = dropdown.parentElement.getElementsByClassName(
						'js-navbar-mega-dropdown-toggler'
					)[0];
					if (toggler) {
						toggler.setAttribute('aria-expanded', 'false');
					}
				}
			});
		}
	}

	private _handleScroll() {
		if (document.body.classList.contains('going-down')) {
			this._handleScrollDown();
		} else if (document.body.classList.contains('going-up')) {
			this._handleScrollUp();
		}
	}

	private _handleScrollDown() {
		if (getWindowScrollTop() > this._height) {
			this._update(-this._height);
			// this._sidebar._update(0);
		}
	}

	private _handleScrollUp() {
		if (getWindowScrollTop() <= this._height) {
			this._update(0);
			// this._sidebar._update(this._height);
		} else {
			this._update(0);
			// this._sidebar._update(this._height);
		}
	}
}
